<template>
  <hic-list-page :entities="entities" :condition="condition" @load="query" :loading="meta.loading" title="检验" keywordPlaceholder="检验项目名称、床位号" hide-search-dialog>
    <template slot="buttons">
      <el-date-picker v-model="excelMonth" type="month" value-format="yyyy-MM" size="small" placeholder="请选择月份" :clearable="false" style="width: 110px;"></el-date-picker>
      <el-button type="success" size="mini" icon="el-icon-document" @click="exportExcel()" style="margin-left: 3px;">检验费用明细</el-button>  
    </template>

    <template slot="search">
      <el-date-picker type="daterange" v-model="meta.dateRange" size="small" range-separator="至" start-placeholder="申请开始日期" end-placeholder="申请结束日期" placeholder="申请日期" style="width: 270px" @change="dateChange" ></el-date-picker>
    </template>

    <el-table-column label="操作 " key="action" align="center" width="100">
      <template #default="{ row }">
        <el-button v-if="row.attachmentId" slot="reference" type="warning" size="mini" icon="el-icon-document" circle plain title="查看报告" @click="view(row)" />
      </template>
    </el-table-column>
    <el-table-column label="状态" prop="state" key="state" align="center" min-width="100" :filters="dictEnum.LisRecordState" column-key="states">
      <template slot-scope="{ row }">
        <el-tag v-if="row.state == '待接收'" type="info" size="small" hit effect="dark">{{ row.state }}</el-tag>
        <el-tag v-else-if="row.state == '待检验'" type="primary" size="small" hit effect="dark">{{ row.state }}</el-tag>
        <el-tag v-else-if="row.state == '样本拒收'" type="warning" size="small" hit effect="dark">{{ row.state }}</el-tag>
        <el-tag v-else-if="row.state == '报告发出'" type="success" size="small" hit effect="dark">{{ row.state }}</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="床位号" prop="bedNo" key="bedNo" min-width="100"></el-table-column>
    <el-table-column label="患者姓名" prop="patientName" key="patientName" min-width="120"></el-table-column>
    <el-table-column label="性别" prop="patientGender" key="patientGender" align="center" min-width="80">
      <template slot-scope="{ row }">
        {{ row.patientGender | dictText("Gender") }}
      </template>
    </el-table-column>
    <el-table-column label="年龄" prop="patientAge" key="patientAge" align="center" min-width="80"></el-table-column>
    <el-table-column label="检验项目" prop="name" key="name" min-width="260"></el-table-column>
    <el-table-column label="开嘱医生" prop="issuedDoctorName" key="issuedDoctorName" min-width="100"></el-table-column>
    <el-table-column label="申请时间" prop="issuedTime" key="issuedTime" align="center" min-width="160"></el-table-column>
    <el-table-column label="执行护士" prop="execNurseName" key="execNurseName" min-width="100"></el-table-column>
    <el-table-column label="接收人" prop="lisReceiveUserName" key="lisReceiveUserName" min-width="100"></el-table-column>
    <el-table-column label="接收时间" prop="lisReceiveTime" key="lisReceiveTime" align="center" min-width="160"></el-table-column>
    <el-table-column label="报告发出时间" prop="lisTestReportTime" key="lisTestReportTime" align="center" min-width="160"></el-table-column>
    <el-table-column label="拒收原因" prop="lisReceiveMemo" key="lisReceiveMemo" align="center" min-width="160" show-overflow-tooltip></el-table-column>
  </hic-list-page>
</template>
<script>
  import { mapGetters } from "sw-hic";
  import api from "./api";
  export default {
    data() {
      return {
        meta: {
          loading: false,
          dateRange: [],
        },
        condition: {
          sort: "issuedTime,id",
          asc: false,
          ids: [],
          pageSize: 20,
          pageIndexOnView: 1,
          issuedDate: null,
        },
        excelMonth: new Date(),
        entities: {},
      }
    },
    computed: {
      ...mapGetters(["dictEnum", "user", "setting"]),
    },
    methods: {
      query() {
        this.meta.loading = true;
        api.LisRecord.query(this.condition)
          .then((res) => {
            this.$set(this, "entities", res);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      view(row) {
        api.Attachment.get(row.attachmentId)
          .then((res) => {
            window.open('/api' + res.url, '_blank');
          })
          .finally(() => {
          });
      },
      exportExcel() {
        if (this.excelMonth instanceof Date) {
          this.excelMonth = this.$utils.Fmt.date(this.excelMonth).substr(0, 7);
        }
        api.ExportExcel.getExcel(this.excelMonth).then((res) => {
          this.$message.success("下载成功!");
        });
      },
      dateChange(v) {
        if (v) {
          if (Array.isArray(v)) {
            this.condition.issuedTimeStart = this.$utils.Fmt.startDatetime(v[0]);
            this.condition.issuedTimeEnd = this.$utils.Fmt.endDatetime(v[1]);
          } else {
            this.condition.issuedTimeStart = this.$utils.Fmt.startDatetime(v);
            this.condition.issuedTimeEnd = this.$utils.Fmt.endDatetime(v);
          }
        } else {
          this.condition.issuedTimeStart = null;
          this.condition.issuedTimeEnd = null;
        }
        this.query();
      },
    }
  }
</script>